import React, { useState } from "react";
import { Button, Table, Form, Badge } from "react-bootstrap";
import CommStatCards from "./CommStatCards";

const STATUS_STYLES = {
  Delivered: { bg: "#ecfdf5", color: "#10b981" },
  Sent: { bg: "#eff6ff", color: "#2563eb" },
  Read: { bg: "#f5f3ff", color: "#7c3aed" },
  Pending: { bg: "#fffbeb", color: "#d97706" },
  Failed: { bg: "#fef2f2", color: "#dc2626" },
};

const StatusBadge = ({ status }) => {
  const s = STATUS_STYLES[status] || STATUS_STYLES.Pending;
  return (
    <span
      style={{
        fontSize: "11px",
        fontWeight: 600,
        color: s.color,
        backgroundColor: s.bg,
        padding: "4px 10px",
        borderRadius: "12px",
        whiteSpace: "nowrap",
      }}
    >
      {status}
    </span>
  );
};

/**
 * Generic "Messages" sub-tab body — stat cards + searchable table.
 * Used by both WhatsApp and SMS message tabs.
 */
const MessagesPanel = ({ channel, accentColor, stats = [], messages = [], onNewMessage }) => {
  const [search, setSearch] = useState("");

  const filtered = messages.filter((m) => {
    const q = search.toLowerCase();
    return (
      m.recipient.toLowerCase().includes(q) ||
      m.audience.toLowerCase().includes(q) ||
      m.message.toLowerCase().includes(q)
    );
  });

  return (
    <div>
      {stats.length > 0 && <CommStatCards stats={stats} />}

      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
        <div style={{ position: "relative", maxWidth: "320px", width: "100%" }}>
          <i
            className="fal fa-search"
            style={{
              position: "absolute",
              left: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#adb5bd",
              fontSize: "13px",
            }}
          />
          <Form.Control
            type="text"
            placeholder="Search messages..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ paddingLeft: "34px", borderRadius: "8px", fontSize: "13px" }}
          />
        </div>
        <Button
          onClick={onNewMessage}
          disabled={!onNewMessage}
          style={{
            border: "none",
            backgroundColor: accentColor,
            borderRadius: "8px",
            fontSize: "13px",
            fontWeight: 600,
            padding: "8px 16px",
          }}
        >
          <i className="fal fa-paper-plane me-2" /> New {channel} Message
        </Button>
      </div>

      <div className="comm-table-wrap">
        <Table hover responsive className="comm-table mb-0">
          <thead>
            <tr>
              <th>Recipient</th>
              <th>Audience</th>
              <th>Message</th>
              <th>Status</th>
              <th>Sent On</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length > 0 ? (
              filtered.map((m) => (
                <tr key={m.id}>
                  <td>
                    <div className="fw-bold" style={{ color: "#212529" }}>
                      {m.recipient}
                    </div>
                    <div className="text-muted" style={{ fontSize: "12px" }}>
                      {m.phone}
                    </div>
                  </td>
                  <td>
                    <Badge
                      pill
                      variant="light"
                      style={{ fontWeight: 500, fontSize: "11px" }}
                    >
                      {m.audience}
                    </Badge>
                  </td>
                  <td style={{ maxWidth: "320px" }}>
                    <span
                      className="text-muted"
                      style={{ fontSize: "13px" }}
                      title={m.message}
                    >
                      {m.message.length > 60
                        ? `${m.message.slice(0, 60)}...`
                        : m.message}
                    </span>
                  </td>
                  <td>
                    <StatusBadge status={m.status} />
                  </td>
                  <td className="text-muted" style={{ fontSize: "13px" }}>
                    {m.sentOn}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} className="text-center text-muted py-5">
                  {messages.length === 0 ? (
                    <>
                      <i className="fab fa-whatsapp d-block mb-2" style={{ fontSize: 36, opacity: 0.2 }} />
                      No messages yet. Click "New {channel} Message" to send one from a template.
                    </>
                  ) : (
                    "No messages match your search."
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default MessagesPanel;
